<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <app-barra-titulo [modulo]="modulo"></app-barra-titulo>

  <section class="content">
    <div class="container-fluid">
      <div *ngIf="!mostrarComponentes">
        <img src="assets/img/logo.png" alt="Logo" class="welcome">
      </div>

      <div *ngIf="mostrarComponentes" class="card card-light">
        <div class="card-header">
          <h3 class="card-title">Panel</h3>
          <div class="card-tools">
            <button type="button" class="btn btn-light">
              <i class="fa fa-plus"></i>
              Botón de acción
            </button>
          </div>
        </div>

        <div class="card-body">
          <h3 style="margin-bottom: 20px;">TABLA</h3>
          <form class="row" [formGroup]="filtrosForm" (ngSubmit)="loadTabla()" novalidate>
            <div class="col-md-12">
              <div class="form-group col-md-8">
                <label for="nombre">Buscar</label>
                <input type="text" class="form-control uppercase" id="busqueda" formControlName="busqueda">
              </div>
              <div class="form-group col-md-12 fright text-right">
                <button type="submit" class="btn btn-outline-primary col-md-2">
                  <fa-icon [icon]="faSearch"></fa-icon> Consultar
                </button>
              </div>
            </div>
          </form>

          <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover table-sm table-fw scrollable-x">
              <thead>
                <tr>
                  <th scope="col">Columna 1</th>
                  <th scope="col">Columna 2</th>
                  <th scope="col">Columna 3</th>
                  <th scope="col">Columna 4</th>
                  <th scope="col">Columna 5</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of tabla.datos">
                  <td>
                    <ngb-highlight [result]="item.columna1 | date: 'dd/MM/yyyy'"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.columna2"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.columna3"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.columna4"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.columna5"></ngb-highlight>
                  </td>
                  <td>
                    <div class="text-center">
                      <a [routerLink]="" title="Ver detalle" class="table-btn-row custom-icon">
                        <i class="fas fa-eye mr-1" aria-hidden="true"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row table-pagination">
            <div class="col-md-6 fleft">
              Pagina {{tabla.paginaInicial}} de
              {{tabla.paginaFinal}} |
              {{tabla.totalRegistros}} Registros
            </div>
            <div class="col-md-6" [ngClass]="{'hidden': tabla.ocultarPaginado}">
              <ul class="pagination fright">
                <li class="btn btn-outline-default">
                  <a [routerLink]="" (click)="loadTabla(tabla.links.linkPrimero)">
                    Primero
                  </a>
                </li>
                <li class="btn btn-outline-default">
                  <a [routerLink]="" (click)="loadTabla(tabla.links.linkAnterior)">
                    Anterior
                  </a>
                </li>
                <li class="btn btn-outline-default">
                  <a [routerLink]="" (click)="loadTabla(tabla.links.linkSiguiente)">
                    Siguiente
                  </a>
                </li>
                <li class="btn btn-outline-default">
                  <a [routerLink]="" (click)="loadTabla(tabla.links.linkUltimo)">
                    Ultimo
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card-body">
          <h3 style="margin-bottom: 20px;">TABLA CON CABECERO ESTÁTICO</h3>
          <div class="row">
            <div class="col-12">
              <div class="card card-light">
                <div class="card-header">
                  <h3 class="card-title">TITULO DE LA TABLA</h3>

                  <div class="card-tools">
                    <form class="row" [formGroup]="filtrosForm" (ngSubmit)="loadTabla()" novalidate>
                      <div class="input-group input-group-sm" style="width: 300px;">
                        <input type="text" name="table_search" class="form-control float-right" placeholder="Search">
                        <div class="input-group-append">
                          <button type="submit" class="btn btn-default"><i class="fas fa-search"></i></button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <!-- /.card-header -->
                <div class="card-body table-responsive table-hover p-0" style="height: auto; max-height: 600px;">
                  <table class="table table-head-fixed">
                    <thead>
                      <tr>
                        <th scope="col">Columna 1</th>
                        <th scope="col">Columna 2</th>
                        <th scope="col">Columna 3</th>
                        <th scope="col">Columna 4</th>
                        <th scope="col">Columna 5</th>
                        <th scope="col">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of tabla.datos">
                        <td>
                          <ngb-highlight [result]="item.columna1 | date: 'dd/MM/yyyy'"></ngb-highlight>
                        </td>
                        <td>
                          <ngb-highlight [result]="item.columna2"></ngb-highlight>
                        </td>
                        <td>
                          <ngb-highlight [result]="item.columna3"></ngb-highlight>
                        </td>
                        <td>
                          <ngb-highlight [result]="item.columna4"></ngb-highlight>
                        </td>
                        <td>
                          <ngb-highlight [result]="item.columna5"></ngb-highlight>
                        </td>
                        <td>
                          <div class="text-center">
                            <a [routerLink]="" title="Ver detalle" class="table-btn-row custom-icon">
                              <i class="fas fa-eye mr-1" aria-hidden="true"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                  </table>
                </div>
                <!-- /.card-body -->
              </div>
              <div class="card-footer clearfix">
                <div class="col-md-6 float-left">
                  Pagina {{tabla.paginaInicial}} de
                  {{tabla.paginaFinal}} |
                  {{tabla.totalRegistros}} Registros
                </div>
                <ul class="pagination pagination-sm m-0 float-right" [ngClass]="{'hidden': tabla.ocultarPaginado}">
                  <li class="page-item">
                    <a class="page-link" [routerLink]="" (click)="loadTabla(tabla.links.linkPrimero)">
                      &laquo;
                    </a>
                  </li>
                  <li class="page-item">
                    <a class="page-link" [routerLink]="" (click)="loadTabla(tabla.links.linkAnterior)">
                      &laquo;
                    </a>
                  </li>
                  <li class="page-item">
                    <a class="page-link" [routerLink]="">
                      {{tabla.paginaInicial}}
                    </a>
                  </li>
                  <li class="page-item">
                    <a class="page-link" [routerLink]="" (click)="loadTabla(tabla.links.linkSiguiente)">
                      &raquo;
                    </a>
                  </li>
                  <li class="page-item">
                    <a class="page-link" [routerLink]="" (click)="loadTabla(tabla.links.linkUltimo)">
                      &raquo;
                    </a>
                  </li>
                </ul>
              </div>
              <!-- /.card -->
            </div>
          </div>
        </div>

        <div class="card-body">
          <form [formGroup]="formularioForm" (ngSubmit)="processForm()" novalidate>
            <div class="row" style="margin-bottom: 20px;">
              <h3 class="col-md-12" style="margin-bottom: 20px;">FORMULARIO</h3>
              <div class="form-group col-md-4">
                <label for="input">Input</label>
                <input type="input" class="form-control" id="input" formControlName="input"
                  [ngClass]="{ 'is-invalid': submitted && fof.input.errors }">
                <div *ngIf="submitted && fof.input.errors" class="invalid-feedback">
                  <div *ngIf="fof.input.errors.required">Campo requerido</div>
                </div>
              </div>

              <div class="form-group col-md-4">
                <label for="combo">Combo</label>
                <select class="form-control" id="combo" formControlName="combo"
                  [ngClass]="{ 'is-invalid': submitted && fof.combo.errors }">
                  <div *ngIf="submitted && fof.combo.errors" class="invalid-feedback">
                    <div *ngIf="fof.combo.errors.required">Campo requerido</div>
                  </div>
                  <option *ngFor="let item of comboList" [value]="item">{{item.name}}</option>
                </select>
              </div>

              <div class="form-group col-md-4">
                <label for="date">Date</label>
                <input type="date" class="form-control" id="date" formControlName="date"
                  [ngClass]="{ 'is-invalid': submitted && fof.date.errors }">
                <div *ngIf="submitted && fof.date.errors" class="invalid-feedback">
                  <div *ngIf="fof.date.errors.required">Campo requerido</div>
                </div>
              </div>

              <div class="form-group col-md-4">
                <label for="email">Email</label>
                <input type="email" class="form-control" id="email" placeholder="email@example.com"
                  formControlName="email" [ngClass]="{ 'is-invalid': submitted && fof.email.errors }">
                <div *ngIf="submitted && fof.email.errors" class="invalid-feedback">
                  <div *ngIf="fof.email.errors.required">Campo requerido</div>
                  <div *ngIf="fof.email.errors.email">Email invalido</div>
                </div>
              </div>

              <div class="form-group col-md-4">
                <label for="phone">Phone</label>
                <input class="form-control" type="text" placeholder="(555)-555-5555" id="phone" formControlName="phone"
                  [specialCharacters]="[ '(' ,'-',' ',')' , '\\' ]" mask="(000)-000-0000"
                  [ngClass]="{ 'is-invalid': submitted && fof.phone.errors }">
                <div *ngIf="submitted && fof.phone.errors" class="invalid-feedback">
                  <div *ngIf="fof.phone.errors.required">Campo requerido</div>
                </div>
              </div>

              <div class="form-group col-md-4">
                <label for="password">Password</label>
                <input type="password" class="form-control" id="password" formControlName="password"
                  [ngClass]="{ 'is-invalid': submitted && fof.password.errors }">
                <div *ngIf="submitted && fof.password.errors" class="invalid-feedback">
                  <div *ngIf="fof.password.errors.required">Campo requerido</div>
                </div>
              </div>
            </div>

            <div class="row" style="margin-bottom: 20px;">
              <h3 class="col-md-12" style="margin-bottom: 20px;">BOTONERA</h3>
              <div class="box-footer clearfix">
                <button type="button" class="btn btn-primary col-md-2" (click)="info(false)">
                  <i class="fa fa-check-circle"></i>
                  Informacion
                </button>
                <button type="button" class="btn btn-warning col-md-2" (click)="warning(false)">
                  <i class="fa fa-check-circle"></i>
                  Advertencia
                </button>
                <button type="button" class="btn btn-danger col-md-2" (click)="error(false)">
                  <i class="fa fa-check-circle"></i>
                  Error
                </button>
                <button type="button" class="btn btn-success col-md-2" (click)="success(false)">
                  <i class="fa fa-check-circle"></i>
                  Exito
                </button>
                <button type="button" class="btn btn-default col-md-2" (click)="question()">
                  <i class="fa fa-check-circle"></i>
                  Confirmacion
                </button>
                <button type="submit" class="btn btn-dark col-md-2">
                  <i class="fa fa-check-circle"></i>
                  Dark
                </button>
              </div>
            </div>

            <div class="row">
              <h3 class="col-md-12" style="margin-bottom: 20px;">BOTONERA (ALERTAS)</h3>
              <div class="box-footer clearfix">
                <button type="button" class="btn btn-primary col-md-2" (click)="info(true)">
                  <i class="fa fa-check-circle"></i>
                  Informacion
                </button>
                <button type="button" class="btn btn-warning col-md-2" (click)="warning(true)">
                  <i class="fa fa-check-circle"></i>
                  Advertencia
                </button>
                <button type="button" class="btn btn-danger col-md-2" (click)="error(true)">
                  <i class="fa fa-check-circle"></i>
                  Error
                </button>
                <button type="button" class="btn btn-success col-md-2" (click)="success(true)">
                  <i class="fa fa-check-circle"></i>
                  Exito
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="card-body">
          <div class="row">
            <h3 class="col-md-12" style="margin-bottom: 20px;">MODALES</h3>
            <button type="button" class="btn btn-dark col-md-6" (click)="showModal()">
              <i class="fa fa-check-circle"></i>
              Modal Normal
            </button>
            <button type="button" class="btn btn-dark col-md-6" (click)="showModalCargando()">
              <i class="fa fa-check-circle"></i>
              Modal Cargando
            </button>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <h3 class="col-md-12" style="margin-bottom: 20px;">ASISTENTES</h3>

            <div id="stepperForm" class="bs-stepper linear">
              <div class="bs-stepper-header" role="tablist">
                <div class="step active" data-target="#test-form-1">
                  <button type="button" class="step-trigger" role="tab" id="stepperFormTrigger1"
                    aria-controls="test-form-1" aria-selected="true">
                    <span class="bs-stepper-circle">1</span>
                    <span class="bs-stepper-label">Email</span>
                  </button>
                </div>
                <div class="bs-stepper-line"></div>
                <div class="step" data-target="#test-form-2">
                  <button type="button" class="step-trigger" role="tab" id="stepperFormTrigger2"
                    aria-controls="test-form-2" aria-selected="false" disabled="disabled">
                    <span class="bs-stepper-circle">2</span>
                    <span class="bs-stepper-label">Password</span>
                  </button>
                </div>
                <div class="bs-stepper-line"></div>
                <div class="step" data-target="#test-form-3">
                  <button type="button" class="step-trigger" role="tab" id="stepperFormTrigger3"
                    aria-controls="test-form-3" aria-selected="false" disabled="disabled">
                    <span class="bs-stepper-circle">3</span>
                    <span class="bs-stepper-label">Validate</span>
                  </button>
                </div>
              </div>
              <div class="bs-stepper-content">
                <form class="needs-validation was-validated" onsubmit="return false" novalidate="">
                  <div id="test-form-1" role="tabpanel" class="bs-stepper-pane fade active dstepper-block"
                    aria-labelledby="stepperFormTrigger1">
                    <div class="form-group">
                      <label for="inputMailForm">Email address <span
                          class="text-danger font-weight-bold">*</span></label>
                      <input id="inputMailForm" type="email" class="form-control" placeholder="Enter email" required="">
                      <div class="invalid-feedback">Please fill the email field</div>
                    </div>
                    <button class="btn btn-primary btn-next-form">Next</button>
                  </div>
                  <div id="test-form-2" role="tabpanel" class="bs-stepper-pane fade dstepper-none"
                    aria-labelledby="stepperFormTrigger2">
                    <div class="form-group">
                      <label for="inputPasswordForm">Password <span
                          class="text-danger font-weight-bold">*</span></label>
                      <input id="inputPasswordForm" type="password" class="form-control" placeholder="Password"
                        required="">
                      <div class="invalid-feedback">Please fill the password field</div>
                    </div>
                    <button class="btn btn-primary btn-next-form">Next</button>
                  </div>
                  <div id="test-form-3" role="tabpanel" class="bs-stepper-pane fade text-center dstepper-none"
                    aria-labelledby="stepperFormTrigger3">
                    <button type="submit" class="btn btn-primary mt-5">Submit</button>
                  </div>
                </form>
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>
  </section>
</div>
<app-footer></app-footer>